module.exports = __webpack_public_path__ + "static/img/ic_Real.d5b2a1c6.png";